import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryEntry() {
  return (
    <section>
      <div className="mb-4 flex items-end justify-between">
        <div>
          <h2 className="text-lg font-bold text-foreground-950 md:text-xl">
            题材分类
          </h2>
          <p className="mt-1 text-xs text-foreground-500 md:text-sm">
            按你喜欢的题材快速进入，找到下一部想看的韩漫
          </p>
        </div>
        <Link
          to="/category/romance"
          className="hidden items-center gap-1 whitespace-nowrap text-sm text-primary-700 hover:text-primary-800 sm:flex"
        >
          浏览全部
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-7">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-3 py-5 transition-colors duration-200 hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${cat.icon} text-2xl`} />
            </span>
            <span className="text-sm font-semibold text-foreground-900">
              {cat.name}
            </span>
            <span className="text-[11px] text-foreground-500">
              {cat.count} 部作品
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}